import React from 'react';
// import Header from '../lib-ui/Header';
import { useState, useEffect } from 'react';
import { Stack, Box } from '@mui/material';
import Config from '../../../lib/Config';
import axios from 'axios';
import '../../../assets/style/fonts.css';
import '../../../assets/style/common.css';
//import bg_img from '../../assets/images/main_bg.jpg';
import Util from '../../../lib/Util';
//import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import PersonIcon from '@mui/icons-material/Person';
import Button from '@mui/material/Button';
//import TopBar from '../common/TopBar';
//import MainTitle from '../../lib-ui/common/MainTitle';
// import ConfirmDialog from '../lib/ConfirmDialog';
import ConfirmDialog from '../../../lib-ui/common/ConfirmDialog'

// import TopBarWhite from '../../lib-ui/common/TopBarWhite';
import { object, string, number, date, InferType } from 'yup';
import { useForm, Controller, formState } from 'react-hook-form';
// import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import UIString from '../../../assets/content/UIString';
import Footer from '../../../lib-ui/common/Footer';
import BusinessIcon from '@mui/icons-material/Business';
import MainHeader from '../MainHeader';
import MainFooter from '../MainFooter';
import '../../../assets/style/base.css';









export default () => {

    const [lang, setLang] = useState('ko');
    //const navigate = useNavigate();
    const [confirmDialogText, setConfirmDialogText] = useState('');
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [showPW, setShowPW] = useState(false);

    useEffect(() => {
        //  setLang(Util.get_url_lang());
    }, []);

    function showConfirmAlert(text) {
        setConfirmDialogText(text);
        setShowConfirmDialog(true);
    }

    // Test

    // Define Yup schema
    const schema = Yup.object().shape({
        login: Yup.object().shape({
            // corp_code: Yup.string().matches(/^([0-9a-zA-Z]{6,22})$/,UIString[lang].INVALID_CORP_CODE_FORMAT).required(UIString[lang].CORP_CODE_IS_REQUIRED),
            //  email: Yup.string().email(UIString[lang].INVALID_EMAIL_FORMAT).required(UIString[lang].EMAIL_IS_REQUIRED),
            //  password: Yup.string().min(6, UIString[lang].INVALID_PASSWORD_FORMAT).max(40, UIString[lang].INVALID_PASSWORD_FORMAT).required(UIString[lang].PASSWORD_IS_REQUIRED),
        }),
    });

    // Use react-hook-form with Yup
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    // Handle form submission
    const onSubmit = (data) => {

        console.log('Form data:', data.login.email + ' / ' + data.login.password);


        axios.post('/ko/api/v1/admin/auth/login', {
            //corp_code: data.login.corp_code,
            email: data.login.email,
            password: data.login.password,
        })
            .then(response => {
                console.log('Success:', response.data);
                if (!response.data.result) {
                    showConfirmAlert(response.data.error);
                } else {
                    document.location.href = Config.BASE_URL + '/admin/dashboard';
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
    };
    //////////////////////////////////








    const login = (e) => {
        e.preventDefault();
        alert('login');
    };

    // const { control, handleSubmit, errors } = useForm();

    return (
        <div style={{ width: '100%', height: '98vh', fontFamily: 'Roboto', fontSize: '13px', padding:'0x' }}>
            <table className={"base_table"} cellspacing={'0px'} cellpadding={'0px'}>
                <tr>
                    <td style={{height:'48px'}}>
                        <MainHeader />
                    </td>
                </tr>
                <tr>
                    <td style={{textAlign:'center',verticalAlign:'top'}}>



            <div style={{ width: '1000px', margin: '0px auto', paddingTop: '180px', textAlign: 'center', backgroundColor: '#ffffff', fontFamily: 'Roboto' }}>
                <div style={{ fontSize: '16px', margin: '0px auto' }}>Password reset request</div>
                <div style={{ height: '60px' }}></div>

                <form method='POST' onSubmit={handleSubmit(onSubmit)} >



                    <Controller
                        //as={Input}
                        name="login.email"
                        id="email"
                        //label="First Name"

                        control={control}
                        // value={data.firstName}
                        //rules={{ required: true }}
                        //errors={errors.firstName}
                        // onChange={([e]) => onChangeHandler(e)}
                        render={({ field }) =>
                            <TextField
                                {...field}
                                error={!errors.login?.email}
                                helperText={errors.login?.email ? errors.login.email.message : ''}
                                placeholder={UIString[lang].EMAIL}
                                variant="outlined"
                                style={{ height: '42px', width: '340px', marginBottom: '28px' }}

                                FormHelperTextProps={{
                                    sx: {
                                        color: errors.login?.email ? 'red' : 'green', // Customize color based on validation
                                    },
                                }}


                                InputProps={{
                                    sx: {
                                        height: '42px',
                                        fontSize: '13px', backgroundColor: '#00ff00',
                                        '&.MuiOutlinedInput-root': {
                                            backgroundColor: '#f8f8f8',  // Set grey background
                                            '& fieldset': {
                                                border: 'none',              // Remove border even when focused
                                            },
                                            '&:hover fieldset': {
                                                border: 'none',              // Remove border on hover
                                            },
                                            '&.Mui-focused fieldset': {
                                                border: 'none',              // Remove border when focused
                                            },
                                        },
                                        '::placeholder': {
                                            fontSize: '12px',              // Set placeholder font size
                                        },
                                    },

                                    endAdornment: (
                                        <InputAdornment position="end" sx={{ paddingRight: '8px' }}>
                                            <IconButton
                                                tabIndex={-1}
                                                edge="end"
                                                sx={{ padding: 0 }} // Optional: adjust icon padding
                                            >
                                                <PersonIcon sx={{ fontSize: '18px' }} />
                                            </IconButton>
                                        </InputAdornment>
                                    ),

                                }}
                                sx={{

                                    "& .MuiInputBase-root": {
                                        "&:-webkit-autofill": {
                                            WebkitBoxShadow: "0 0 0 100px white inset", // Background color
                                            WebkitTextFillColor: "black", // Text color
                                            WebkitTextFillColor: "black", // Text color
                                            backgroundColor: "#ffffff !important", // Explicit background reset
                                        },
                                    },

                                    backgroundColor: "#ffffff !important",
                                    "& .MuiInputBase-root": {

                                        "&:-webkit-autofill": {

                                            WebkitBoxShadow: "0 0 0 100px white inset", // Background color
                                            WebkitTextFillColor: "black", // Text color
                                        },
                                    },

                                    '& .MuiInputBase-input::placeholder': {
                                        fontSize: '12px',                // Ensure placeholder font size
                                    },

                                    "& .MuiInputBase-root": {
                                        height: "42px", // Fixed height for the input container
                                        paddingTop: "0", // Reset padding to prevent autofill changes
                                        paddingBottom: "0",
                                    },
                                    "& input": {
                                        height: "100%", // Ensure the inner input spans the full height
                                        paddingTop: "0", // Reset padding to prevent autofill changes
                                        paddingBottom: "0",
                                        boxSizing: "border-box", // Ensure consistent box model
                                        paddingTop: "0", // Reset padding to prevent autofill changes
                                        paddingBottom: "0",
                                    },
                                    "& .MuiInputBase-root:-webkit-autofill": {
                                        WebkitBoxShadow: "0 0 0 100px white inset", // Remove background color
                                        WebkitTextFillColor: "black", // Text color
                                        paddingTop: "0", // Reset padding to prevent autofill changes
                                        paddingBottom: "0",
                                    },
                                    "& .MuiInputBase-input": {
                                        paddingTop: "0", // Reset padding to prevent autofill changes
                                        paddingBottom: "0",
                                    },
                                }}

                            />
                        }
                    />





                    <br />

                    <Controller
                        //as={Input}
                        name="login.password"
                        id="password"
                        //label="First Name"

                        control={control}
                        // value={data.firstName}
                        //rules={{ required: true }}
                        //errors={errors.firstName}
                        // onChange={([e]) => onChangeHandler(e)}
                        render={({ field }) => <TextField
                            {...field}
                            error={!errors.login?.password}
                            helperText={errors.login?.password ? errors.login.password.message : ''}
                            FormHelperTextProps={{
                                sx: {
                                    color: errors.login?.password ? 'red' : 'green', // Customize color based on validation
                                },
                            }}

                            placeholder={UIString[lang].PASSWORD}
                            variant="outlined"
                            type={showPW ? 'text' : 'password'}
                            style={{ height: '42px', width: '340px', marginBottom: '36px' }}
                            InputProps={{
                                sx: {
                                    height: '42px',
                                    fontSize: '13px',
                                    '&.MuiOutlinedInput-root': {
                                        backgroundColor: '#f8f8f8',  // Set grey background
                                        '& fieldset': {
                                            border: 'none',              // Remove border even when focused
                                        },
                                        '&:hover fieldset': {
                                            border: 'none',              // Remove border on hover
                                        },
                                        '&.Mui-focused fieldset': {
                                            border: 'none',              // Remove border when focused
                                        },
                                    },
                                    '::placeholder': {
                                        fontSize: '12px',              // Set placeholder font size
                                    },
                                },


                                endAdornment: (
                                    <InputAdornment position="end" sx={{ paddingRight: '8px' }}>
                                        <IconButton
                                            tabIndex={-1}
                                            onClick={() => { setShowPW(!showPW); }}
                                            edge="end"
                                            sx={{ padding: 0 }} // Optional: adjust icon padding
                                        >
                                            {showPW ? <Visibility sx={{ fontSize: '18px' }} /> : <VisibilityOff sx={{ fontSize: '18px' }} />}
                                        </IconButton>
                                    </InputAdornment>
                                ),


                            }}
                            sx={{
                                height: '42px',
                                '& .MuiInputBase-input::placeholder': {
                                    height: '42px',
                                    fontSize: '13px',                // Ensure placeholder font size
                                    paddingTop: "0", // Reset padding to prevent autofill changes
                                    paddingBottom: "0",
                                },
                                "& .MuiInputBase-root": {
                                    height: "42px", // Fixed height for the input container
                                    paddingTop: "0", // Reset padding to prevent autofill changes
                                    paddingBottom: "0",
                                },
                                "& input": {
                                    height: "100%", // Ensure the inner input spans the full height

                                    boxSizing: "border-box", // Ensure consistent box model
                                    paddingTop: "0", // Reset padding to prevent autofill changes
                                    paddingBottom: "0",
                                },
                                "& .MuiInputBase-root:-webkit-autofill": {
                                    WebkitBoxShadow: "0 0 0 100px white inset", // Remove background color
                                    WebkitTextFillColor: "black", // Text color
                                    paddingTop: "0", // Reset padding to prevent autofill changes
                                    paddingBottom: "0",

                                },
                                "& .MuiInputBase-input": {
                                    paddingTop: "0", // Reset padding to prevent autofill changes
                                    paddingBottom: "0",

                                },
                            }}



                        />} />








                    <br /><br />
                    <Button variant="text" type='submit' sx={{ color: '#222222', fontSize: '13px', marginTop: '20px', width: '340px', fontFamily: 'Roboto', fontWeight: 'normal', backgroundColor: '#f2f2f2' }}>{UIString[lang].LOGIN}</Button><br />
                    <br />
                    <br />

                </form>


            </div>

           

                    </td>
                </tr>
                <tr>
                    <td style={{height:'200px',textAlign:'center'}}>
                    <MainFooter />
                    <ConfirmDialog show={showConfirmDialog} text={confirmDialogText} confirm_text={UIString[lang].CONFIRM} handle_close={() => { setShowConfirmDialog(false); }} />
                    </td>
                </tr>
            </table>

        </div>
    );

}